import styled from 'styled-components';
import Icon from '../../../_shared/components/Icon';

export const ModalContainer = styled.div`
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL};
  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    height: 100%;
  }
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
`;

export const ModalHeader = styled.div`
  background-color: ${({ theme }) => theme.COLORS.BASE};
  height: 54px;
  padding: 18px;
  width: 100%;
  position: fixed;
`;

ModalHeader.Button = styled.button`
  display: flex;
  padding: 0;
  border: 0;
  background: none;
  outline: none;
  cursor: pointer;
`;

ModalHeader.CloseIcon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  margin-right: 9px;
  width: 18px;
  height: 18px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  letter-spacing: 1.2px;
`;

ModalHeader.Text = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  padding-top: 3px;
`;

export const ModalBody = styled.div`
  padding: 110px 54px 0;
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL};
  min-height: 518px;
  max-height: 518px;
`;

ModalBody.FeesContainer = styled.div`
  box-shadow: 0px 4px 18px rgb(0 0 0 / 20%);
  border-radius: 3px;
  padding: 10px;
  margin-top: 15px;
`;

ModalBody.FeesTable = styled.div`
  display: table;
  width: 100%;
  border-collapse: collapse;
`;

ModalBody.TableHeaderRow = styled.div`
  display: table-row;
  & > div:last-child {
    text-align: right;
  }
`;

ModalBody.TableRow = styled.div`
  display: table-row;
  border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  &:last-of-type {
    border-bottom: none;
  }
  & > div:last-child {
    text-align: right;
  }
`;

ModalBody.TableHeaderCell = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  line-height: 18px;
  display: table-cell;
  padding-bottom: 20px;
`;

ModalBody.TableCell = styled.div`
  display: table-cell;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 30px;
`;

ModalBody.Title = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XLARGE};
  padding-bottom: 21px;
  line-height: 32px;
`;

ModalBody.FirstSection = styled.div`
  padding-bottom: 35px;
  line-height: 24px;
`;

ModalBody.ListHeader = styled.div`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  line-height: 24px;
`;

ModalBody.List = styled.ol`
  padding-left: 22px;
  margin-top: 10px;
  line-height: 24px;
`;

ModalBody.ListItem = styled.li`
  line-height: 24px;
`;

ModalBody.LastSection = styled.div`
  line-height: 24px;
  padding-bottom: 60px;
`;
